export class RenameYourAccountEventType {

	static SEND = {
		RENAME_ACCOUNT_SEND: 'RENAME_ACCOUNT_SEND',
		RENAME_ACCOUNT_CONFIRM: 'RENAME_ACCOUNT_CONFIRM'
	};

	static STEPS = {
		RENAME_ACCOUNT_RESET: 'RENAME_ACCOUNT_RESET',
		RENAME_ACCOUNT_WARNING: 'RENAME_ACCOUNT_WARNING'
	};

	static ERROR = 'RENAME_ACCOUNT_ERROR';
	static BUTTONS = 'RENAME_ACCOUNT_BUTTONS';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rename-your-account/rename-your-account.event.type.ts